




import { Vue, Prop, Component } from "vue-property-decorator";
import moment from "moment";

@Component
export default class Weather extends Vue {
  @Prop() private location!: string;
  private timer = -1;
  private temperature = "---";
  private weatherApi = "https://weather.prod.ki-wi.cz/weather";

  mounted() {
    if (!("caches" in window)) {
      console.warn("caching is not supported");
    }
    this.updateWeather();
    this.timer = setInterval(this.updateWeather, 1000 * 60 * 60 * 2);
  }

  destroyd() {
    clearInterval(this.timer);
  }

  private updateWeather() {
    fetch(this.weatherApi)
      .then(async (res: Response) => {
        if ("caches" in window) {
          const cache = await caches.open("jusda-weather");
          cache.put(this.weatherApi, res.clone());
        }
        this.parseWeather(res.text());
      })
      .catch(async (err: unknown) => {
        console.error(err);
        if ("caches" in window) {
          const cache = await caches.open("jusda-weather");
          const data = await cache.match(this.weatherApi);
          const body = data?.text();
          if (body) {
            this.parseWeather(body);
          } else {
            console.error("No weather cache found.");
          }
        }
      });
  }

  private async parseWeather(data: Promise<string>) {
    if (!data) {
      console.error("weather is undefined");
      return;
    }
    const { forecast } = JSON.parse(await data);
    const todayDate = moment().format("yyyy-MM-DD");
    const nowHour = moment().format(`${todayDate} HH:00`);
    const todayForecast = forecast.forecastday.find(
      (forecastDay: any) => forecastDay.date === todayDate
    );
    const hour = todayForecast.hour.find((hour: any) => hour.time === nowHour);
    this.temperature = `${hour.temp_c} °C`;
  }
}
